import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { IconInCircleWithLabel } from '../../uiComponents/iconInCircleWithLabel/iconInCircleWithLabel.component';
import { hexToRgba } from './../../utils/colors.utils';
import { styleWhenTrue } from '../../utils/render.utils';
import { Color, Spacing, FontWeight, Layer, Media } from '../../theme';

import { FullscreenMenuContainerData, MenuPositionItemData } from './fullscreenMenu.types';
import LocalCloseIcon from './images/close.inline.svg';

export const Container = styled.div<FullscreenMenuContainerData>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${Color.white};
  z-index: ${Layer.FullscreenMenu};
  transition: opacity 0.3s;
  opacity: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  ${styleWhenTrue(prop('isVisible'), css`
    opacity: 1;
    pointer-events: initial;
  `)}
`;

export const CloseIcon = styled(LocalCloseIcon)`
  width: 22px;
  g {
    fill: ${Color.primary};
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  height: 100%;
  ${Media.tablet`
    height: auto;
    overflow-y: auto;
  `}
`;

export const LocalIconInCircleWithLabel = styled(IconInCircleWithLabel)``;

export const MenuColumn = styled.div`
  padding: 23px ${Spacing.DesktopWide} 60px;
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: space-between;
  width: calc(50% - 2 * ${Spacing.DesktopWide});
  ${Media.desktop`
    padding: 23px ${Spacing.Desktop} 60px;
    width: calc(50% - 2 * ${Spacing.Desktop});
  `}
  ${Media.tablet`
    padding: 23px ${Spacing.Tablet} 60px;
    width: calc(100% - 2 * ${Spacing.Tablet});
    ${LocalIconInCircleWithLabel} {
      display: none;
    }
  `}
`;

export const SliderColumn = styled.div`
  padding-top: 20px;
  width: 50%;
  background-color: ${Color.secondary};
  ${Media.tablet`
    display: none;
  `}
`;

export const MenuPositionsContainer = styled.div`
  display: flex;
  margin-top: 70px;
  ${Media.tablet`
    flex-direction: column;
    margin-top: 40px;
  `}
`;

export const MenuPositionItem = styled.div<MenuPositionItemData>`
  font-size: 35px;
  letter-spacing: 0.28px;
  line-height: 20px;
  & + & {
    margin-top: 40px;
    ${Media.tablet`
      margin-top: 30px;
    `}
  }
  a {
    text-decoration: none;
    color: ${Color.darkGrey};
    ${styleWhenTrue(prop('isActive'), css`
      color: ${Color.primary};
    `)}
  }
  ${Media.desktop`
    font-size: 28px;
    letter-spacing: 0.22px;
  `}
  ${Media.tablet`
    font-size: 35px;
    letter-spacing: 0.28px;
  `}
`;

export const MenuPositionsColumn = styled.div`
  &:nth-child(2) {
    margin-left: 100px;
    ${Media.desktop`
      margin-left: 40px;
    `}
    ${Media.tablet`
      margin-left: 0;
      margin-top: 50px;
    `}
    ${MenuPositionItem} {
      font-size: 16px;
      font-weight: ${FontWeight.Light};
      letter-spacing: 0;
      & + ${MenuPositionItem} {
        margin-top: 15px;
        ${Media.tablet`
          margin-top: 10px;
        `}
      }
    }
  }
`;

export const BottomContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 50px;
  ${Media.tablet`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const SocialIconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 56px);
  grid-gap: 10px;
`;

export const SocialIconContainer = styled.a`
  height: 54px;
  width: 54px;
  border: 0.5px solid ${Color.veryLightGrey};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const MenuHeader = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 23px 30px;
  box-shadow: 0 2px 5px 0 ${hexToRgba(Color.silver, 0.15)};
  ${Media.tablet`
    display: flex;
  `}
`;

export const CompanyLogoContainer = styled.div`
  margin-left: 70px;
  ${Media.desktop`
    margin-left: 35px;
  `}
  ${Media.tablet`
    margin-left: 30px;
  `}
`;

export const LogoWithCloseIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseIconWithMenuContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
`;
